import React from 'react';
import { AlertCircle, Inbox, Loader2 } from 'lucide-react';

export function LoadingState({ label = 'Loading…' }) {
  return (
    <div className="page-state">
      <Loader2 size={22} className="spin-icon" />
      <div>{label}</div>
    </div>
  );
}

export function EmptyState({ title = 'Nothing here yet', sub, action, actionLabel }) {
  return (
    <div className="page-state">
      <Inbox size={28} strokeWidth={1.5} style={{ color: 'var(--text3)' }} />
      <div style={{ fontWeight: 600, marginTop: 8 }}>{title}</div>
      {sub && <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4, maxWidth: 360 }}>{sub}</div>}
      {action && actionLabel && (
        <button className="btn btn-p btn-sm" style={{ marginTop: 14 }} onClick={action}>{actionLabel}</button>
      )}
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="page-state" style={{ background: 'var(--danger-bg)', borderRadius: 10, padding: 24 }}>
      <AlertCircle size={22} style={{ color: 'var(--danger)' }} />
      <div style={{ fontWeight: 600, color: 'var(--danger)', marginTop: 8 }}>Something went wrong</div>
      <div style={{ fontSize: 12, color: 'var(--danger)', marginTop: 4 }}>{message || 'Please try again.'}</div>
      {onRetry && (
        <button className="btn btn-o btn-sm" style={{ marginTop: 12 }} onClick={onRetry}>Retry</button>
      )}
    </div>
  );
}

export function SaveIndicator({ status }) {
  if (!status || status === 'idle') return null;
  const map = {
    saving: { text: 'Saving…', color: 'var(--text3)' },
    saved: { text: 'Saved', color: 'var(--success)' },
    error: { text: 'Save failed', color: 'var(--danger)' },
  };
  const m = map[status] || map.saving;
  return (
    <span style={{ fontSize: 11, fontWeight: 500, color: m.color, marginLeft: 8 }}>{m.text}</span>
  );
}
